import { FormControl } from "@atoms"
import { yupResolver } from "@hookform/resolvers/yup"
import { Button, Drawer, DrawerProps, Input } from "antd"
import { Controller, useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { object, string } from "yup"
import { useCreateAccident } from "./queries"
import { useEventId, usePresenceId } from "pages/events"
import { useExecutionMember } from "../queries"
import moment from "moment"
import { useEffect } from "react"

interface Props extends DrawerProps {
  onClose: () => void
}

const CreateAccidentDrawer: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const eventId = useEventId()
  const presenceId = usePresenceId()
  const member = useExecutionMember(eventId!, presenceId!)
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useCreateAccidentForm()

  const { isLoading, mutate } = useCreateAccident(
    eventId!,
    member.data?.member_id!,
    {
      meta: {
        type: "add",
        context: "male",
        entity: t("accidents.accident"),
      },
    }
  )

  const onSubmit = (data: ICreateAccidentForm) => {
    mutate(
      {
        accident_at: `${moment().format("YYYY-MM-DD")} ${data.accident_at}`,
      },
      {
        onSuccess() {
          props.onClose()
          reset()
        },
      }
    )
  }

  useEffect(() => {
    props.open && reset({ accident_at: moment().format("HH:mm") })
  }, [reset, props.open])

  return (
    <Drawer title={t("accidents.add_accident")} {...props}>
      <form>
        <FormControl>
          <Controller
            control={control}
            name="accident_at"
            render={({ field }) => (
              <Input {...field} placeholder={t("labels.time")} type="time" />
            )}
          />

          {errors.accident_at && (
            <FormControl.HelperText>
              {errors.accident_at.message}
            </FormControl.HelperText>
          )}
        </FormControl>
        <Button
          loading={isLoading || member.isLoading}
          type="primary"
          onClick={handleSubmit(onSubmit)}
        >
          {t("global.save")}
        </Button>
      </form>
    </Drawer>
  )
}

export default CreateAccidentDrawer

interface ICreateAccidentForm {
  accident_at: string
}

const useCreateAccidentForm = (defaultValues?: ICreateAccidentForm) => {
  const schema = object().shape({
    accident_at: string().required(),
  })
  return useForm<ICreateAccidentForm>({
    resolver: yupResolver(schema),
    defaultValues,
  })
}
